<template>
  <div
    class="task-list-page-header d-flex justify-space-between align-start"
    data-testid="setup-tasklist__header"
  >
    <div class="task-list-page-header__left">
      <div class="task-list-page-header__title-prefix" data-testid="setup-tasklist__title-prefix">
        Setup
      </div>
      <div
        class="task-list-page-header__title-group d-flex align-center"
        data-testid="setup-tasklist__title-group"
      >
        <h3 class="task-list-page-header__title" data-testid="setup-tasklist__title">
          Task Library
        </h3>
        <v-tooltip bottom content-class="tooltip-bottom">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              small
              class="shadow-off"
              :disabled="loading"
              :loading="loading"
              data-testid="setup-tasklist__refresh-btn"
              @click="$emit('refresh')"
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>Refresh</span>
        </v-tooltip>
      </div>
      <p class="task-list-page-header__description" data-testid="setup-tasklist__subtitle">
        Create and manage reusable task templates to instantly populate your financial close cycles.
      </p>
    </div>
  </div>
</template>

<script>
import './TaskListPageHeader.scss';

export default {
  name: 'TaskListPageHeader',

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
